import { show, hide, trigger } from './utility';

/// show-depends-on-select-other is a special case for show-depends-on-select, this allow the
/// select value to end with Other instead of exact match. (e.g. 'h. Other').
///
/// <div data-gs-toggle="show-depends-on-select-other" data-gs-target="#target"></div>

export default function (targetElem: HTMLElement) {
    let clearName = targetElem.dataset['gsClearName'];
    let customName = targetElem.dataset['gsCustomName'];
    let customTextName = targetElem.dataset['gsCustomTextName'];

    let clearElem: HTMLInputElement = null;
    let customElem: HTMLInputElement = null;
    let customTextElem: HTMLInputElement = null;


    let allElems = targetElem.querySelectorAll('input[type=text],input[type=radio],input[type=checkbox]');
    function clear(selfElem) {
        for (let i = 0; i < allElems.length; ++i) {
            let elem = allElems[i] as HTMLInputElement;
            if (elem == selfElem) {
                //do nothing
            } else if (elem.nodeName === 'INPUT' && elem.type === 'text') {
                elem.value = '';
            } else if (elem.nodeName === 'INPUT' && (elem.type === 'checkbox' || elem.type === 'radio')) {
                elem.checked = false;
            }
        }
    }

    for (let i = 0; i < allElems.length; ++i) {
        let elem = allElems[i] as HTMLInputElement;
        if (elem.name === clearName) {
            if (clearElem !== null) {
                throw new Error(`More than 1 clear element found: ${clearName}`);
            }
            clearElem = elem;
        }
        if (elem.name === customName) {
            customElem = elem;
        } else if (elem.name === customTextName) {
            customTextElem = elem;
        }

        elem.addEventListener('change', (e) => {
            let targetElem = e.target as HTMLInputElement;
            if (targetElem === clearElem && targetElem.checked) {
                clear(targetElem);
            } else if (targetElem !== clearElem && (targetElem.type === 'checkbox' || targetElem.type === 'radio') && targetElem.checked) {
                clearElem.checked = false;
            }
            if (customElem === targetElem && !targetElem.checked) {
                if (customTextElem) {
                    customTextElem.value = '';
                }
            }
        });

        if (customTextElem) {
            customTextElem.addEventListener('input', (e => {
                if (customTextElem.value === '') {
                    customElem.checked = false;
                } else {
                    customElem.checked = true;
                    clearElem.checked = false;
                }
            }));
        }
    }

    if (clearElem == null) {
        throw new Error(`Can not find clear element: ${clearName}`);
    }
}